import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { IcepanelComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanel.component';
import { IcepanelContainerComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanelcontainer.component';
import { LoginService } from '../../../../icemedx-lib/src/login/login.service';
import { AccountingService } from '../../../../icemedx-lib/src/services/accounting/accounting.service';
import { DomainService } from '../../../../icemedx-lib/src/services/domain/domain.service';
import { PatientService } from '../../../../icemedx-lib/src/services/patient/patient.service';
import { PayerService } from '../../../../icemedx-lib/src/services/payer/payer.service';
import { PharmacyService } from '../../../../icemedx-lib/src/services/pharmacy/pharmacy.service';
import { ProviderService } from '../../../../icemedx-lib/src/services/provider/provider.service';
import { VendorService } from '../../../../icemedx-lib/src/services/vendor/vendor.service';
import { AppService } from '../app.service';
import { ServicechargeHistoryComponent } from '../servicechargehistory/servicechargehistory.component';

@Component({
  selector: 'app-claimshistory',
  templateUrl: '../servicechargehistory/servicechargehistory.component.html', //claimshistory.component.html
  styleUrls: ['./claimshistory.component.scss'],
  providers: [AppService, IceNavService, IcepanelComponent, IcepanelContainerComponent]
})
export class ClaimshistoryComponent extends ServicechargeHistoryComponent implements OnInit {

  constructor(appSvc: AppService,
    navSvc: IceNavService,
    domainSvc: DomainService,
    accSvc: AccountingService,
    loginSvc: LoginService,
    router: Router,
    vendorSvc: VendorService,
    proSvc: ProviderService,
    pharmSvc: PharmacyService,
    payerSvc: PayerService,
    patSvc: PatientService,
    activatedRoute: ActivatedRoute) {
      debugger;
      super(appSvc,
        navSvc,
        domainSvc,
        accSvc,
        loginSvc,
        router,
        vendorSvc,
        proSvc,
        pharmSvc,
        payerSvc,
        patSvc,
        activatedRoute);
  }

  ngOnInit() {
    this.getAppService().refreshMenus();
  }

}
